import { render, staticRenderFns } from "./EANLabelCreation.vue?vue&type=template&id=b8d8ef72&scoped=true"
import script from "./EANLabelCreation.vue?vue&type=script&lang=js"
export * from "./EANLabelCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d8ef72",
  null
  
)

export default component.exports